import { IconButton } from '@economic/taco';
import { Trans } from '@lingui/macro';
import React, { PropsWithChildren } from 'react';
import { useHelpDrawer } from '~/app/components/Header/Help/HelpDrawerContext';
import * as inapphelpMixpanel from '~/app/components/Header/Help/tracking';

export function HelpDrawerBackButton({ children }: PropsWithChildren<unknown>): React.JSX.Element {
    const { back } = useHelpDrawer();

    return (
        <div className="flex items-center">
            <IconButton
                icon="chevron-left"
                tooltip={<Trans>Back</Trans>}
                appearance="discrete"
                onClick={() => {
                    inapphelpMixpanel.trackNavigation({ item: 'back', placement: 'help-drawer' });
                    back();
                }}
            />
            {children}
        </div>
    );
}
